import { render, staticRenderFns } from "./PlanChangeModal.vue?vue&type=template&id=b5df23a6"
import script from "./PlanChangeModal.vue?vue&type=script&lang=ts"
export * from "./PlanChangeModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports